import React from 'react';
import { Link } from 'react-router-dom';
import { useNavState } from '../../hooks/useNavState';
import { clearConsent } from '../../consent/consent';

const Footer = () => {
  const { isAuthenticated } = useNavState();
  
  return (
    <footer className="bg-gray-900 border-t border-gray-800 py-12 px-6">
      <div className="container mx-auto">
        {/* Main Footer Content */}
        <div className="grid md:grid-cols-4 gap-8 mb-8">
          
          {/* Company Info */}
          <div>
            <h3 className="text-lg font-semibold text-white mb-4">ChillFree TV</h3>
            <p className="text-gray-400 text-sm mb-4">
              Your destination for classic movies and timeless TV shows. 
              Free streaming with a curated selection of entertainment gems.
            </p>
            {/* Social media links temporarily hidden until proper URLs are available */}
            {false && (
            <div className="flex space-x-4">
              <a href="https://facebook.com/chillfreetv" target="_blank" rel="noopener noreferrer" className="text-gray-400 hover:text-teal-400 transition-colors">
                <span className="sr-only">Facebook</span>
                <svg className="w-5 h-5" fill="currentColor" viewBox="0 0 24 24">
                  <path d="M24 12.073c0-6.627-5.373-12-12-12s-12 5.373-12 12c0 5.99 4.388 10.954 10.125 11.854v-8.385H7.078v-3.47h3.047V9.43c0-3.007 1.792-4.669 4.533-4.669 1.312 0 2.686.235 2.686.235v2.953H15.83c-1.491 0-1.956.925-1.956 1.874v2.25h3.328l-.532 3.47h-2.796v8.385C19.612 23.027 24 18.062 24 12.073z"/>
                </svg>
              </a>
              <a href="https://twitter.com/chillfreetv" target="_blank" rel="noopener noreferrer" className="text-gray-400 hover:text-teal-400 transition-colors">
                <span className="sr-only">Twitter</span>
                <svg className="w-5 h-5" fill="currentColor" viewBox="0 0 24 24">
                  <path d="M23.953 4.57a10 10 0 01-2.825.775 4.958 4.958 0 002.163-2.723c-.951.555-2.005.959-3.127 1.184a4.92 4.92 0 00-8.384 4.482C7.69 8.095 4.067 6.13 1.64 3.162a4.822 4.822 0 00-.666 2.475c0 1.71.87 3.213 2.188 4.096a4.904 4.904 0 01-2.228-.616v.06a4.923 4.923 0 003.946 4.827 4.996 4.996 0 01-2.212.085 4.936 4.936 0 004.604 3.417 9.867 9.867 0 01-6.102 2.105c-.39 0-.779-.023-1.17-.067a13.995 13.995 0 007.557 2.209c9.053 0 13.998-7.496 13.998-13.985 0-.21 0-.42-.015-.63A9.935 9.935 0 0024 4.59z"/>
                </svg>
              </a>
              <a href="https://youtube.com/@chillfreetv" target="_blank" rel="noopener noreferrer" className="text-gray-400 hover:text-teal-400 transition-colors">
                <span className="sr-only">YouTube</span>
                <svg className="w-5 h-5" fill="currentColor" viewBox="0 0 24 24">
                  <path d="M23.498 6.186a3.016 3.016 0 0 0-2.122-2.136C19.505 3.545 12 3.545 12 3.545s-7.505 0-9.377.505A3.017 3.017 0 0 0 .502 6.186C0 8.07 0 12 0 12s0 3.93.502 5.814a3.016 3.016 0 0 0 2.122 2.136c1.871.505 9.376.505 9.376.505s7.505 0 9.377-.505a3.015 3.015 0 0 0 2.122-2.136C24 15.93 24 12 24 12s0-3.93-.502-5.814zM9.545 15.568V8.432L15.818 12l-6.273 3.568z"/>
                </svg>
              </a>
            </div>
            )}
          </div>

          {/* Navigation */}
          <div>
            <h3 className="text-lg font-semibold text-white mb-4">Navigation</h3>
            <ul className="space-y-2">
              <li>
                <Link to="/live-tv" className="text-gray-400 hover:text-teal-400 transition-colors text-sm">
                  Live TV
                </Link>
              </li>
              <li>
                <Link to="/movies" className="text-gray-400 hover:text-teal-400 transition-colors text-sm">
                  Movies
                </Link>
              </li>
              <li>
                <Link to="/series" className="text-gray-400 hover:text-teal-400 transition-colors text-sm">
                  TV Series
                </Link>
              </li>
            </ul>
          </div>

          {/* Support */}
          <div>
            <h3 className="text-lg font-semibold text-white mb-4">Support</h3>
            <ul className="space-y-2">
              <li>
                <Link to="/help/rentals-and-purchases" className="text-gray-400 hover:text-teal-400 transition-colors text-sm">
                  How Rentals Work
                </Link>
              </li>
              <li>
                <Link to="/contact" className="text-gray-400 hover:text-teal-400 transition-colors text-sm">
                  Contact Us
                </Link>
              </li>
              <li>
                <Link to="/about" className="text-gray-400 hover:text-teal-400 transition-colors text-sm">
                  About Us
                </Link>
              </li>
              <li>
                <a href="mailto:support@chillfree.tv" className="text-gray-400 hover:text-teal-400 transition-colors text-sm">
                  Email Support
                </a>
              </li>
              <li>
                <a href="mailto:datarequest@chillfree.tv" className="text-gray-400 hover:text-teal-400 transition-colors text-sm">
                  Privacy Requests
                </a>
              </li>
            </ul>
          </div>

          {/* Legal */}
          <div>
            <h3 className="text-lg font-semibold text-white mb-4">Legal</h3>
            <ul className="space-y-2">
              <li>
                <Link to="/privacy-policy" className="text-gray-400 hover:text-teal-400 transition-colors text-sm">
                  Privacy Policy
                </Link>
              </li>
              <li>
                <Link to="/terms-of-use" className="text-gray-400 hover:text-teal-400 transition-colors text-sm">
                  Terms of Use
                </Link>
              </li>
              <li>
                <Link to="/ccpa" className="text-gray-400 hover:text-teal-400 transition-colors text-sm">
                  CCPA Rights
                </Link>
              </li>
              <li>
                <Link to="/do-not-sell" className="text-gray-400 hover:text-teal-400 transition-colors text-sm">
                  Do Not Sell My Data
                </Link>
              </li>
              <li>
                <button
                  type="button"
                  onClick={() => { clearConsent(); window.location.reload(); }}
                  className="text-gray-400 hover:text-teal-400 transition-colors text-sm bg-transparent border-0 p-0 cursor-pointer"
                >
                  Cookie Preferences
                </button>
              </li>
            </ul>
          </div>

        </div>

        {/* Bottom Bar */}
        <div className="border-t border-gray-800 pt-8">
          <div className="flex flex-col md:flex-row justify-between items-center">
            <div className="text-gray-400 text-sm mb-4 md:mb-0">
              &copy; {new Date().getFullYear()} dotstudioPRO. All rights reserved.
              {isAuthenticated && (
                <span className="ml-2">| Authenticated User</span>
              )}
            </div>
            <div className="flex flex-wrap gap-4 text-sm">
              {/* Removed duplicate links - they're already in the Legal section above */}
              {/* Hidden Matrix Easter Egg */}
              <button 
                onClick={() => {
                  // Create Matrix effect on click
                  const matrixModal = document.createElement('div');
                  matrixModal.className = 'fixed inset-0 bg-black z-50 flex items-center justify-center';
                  matrixModal.innerHTML = `
                    <div class="text-center">
                      <div class="text-6xl font-mono text-green-400 mb-4 animate-pulse">🐰</div>
                      <h2 class="text-3xl font-mono text-green-400 mb-4">Follow the White Rabbit</h2>
                      <p class="text-green-300 font-mono mb-6">You found the hidden path, Neo.</p>
                      <p class="text-green-500/80 font-mono text-sm mb-8">"The Matrix has you..."</p>
                      <button class="bg-red-600 hover:bg-red-700 text-white px-6 py-3 rounded font-mono transition-colors" onclick="this.parentElement.parentElement.remove()">
                        Take the Red Pill
                      </button>
                    </div>
                  `;
                  document.body.appendChild(matrixModal);
                  
                  // Auto-remove after 10 seconds
                  setTimeout(() => {
                    if (matrixModal.parentElement) {
                      matrixModal.remove();
                    }
                  }, 10000);
                }}
                className="text-gray-600 hover:text-green-400 transition-colors text-xs opacity-30 hover:opacity-100"
                title="🐰"
              >
                ·
              </button>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
